import type { CreateMerchantGroupUserRequest } from "./types"
import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const createMerchantGroupUser = async (
  params: CreateMerchantGroupUserRequest
) => {
  await api.post("/merchant-group/users/", {
    body: params,
    isMerchantGroup: true,
  })
  queryClient.invalidateQueries([
    BASE_MERCHANT_GROUP_USERS_QUERY_KEY,
  ])
}
